let ws;

const config = require("./config")

const init = (id, token) => {
  const wsUrl = config.default.socketurl + "/" + id + (token ? "?token=" + token : "");
  ws = new WebSocket(wsUrl);

  ws.onopen = () => {
    console.log("WebSocket connected");
  };

  ws.onmessage = (msg) => {
    try {
      const data = JSON.parse(msg.data);
      // handle message
    } catch (e) {
      console.error("WebSocket received invalid JSON:", e.message);
    }
  };

  ws.onerror = (error) => {
    console.error("WebSocket error:", error);
  };

  ws.onclose = () => {
    console.log("WebSocket disconnected");
  };
};

const send = (msg) => {
  if (ws && ws.readyState === WebSocket.OPEN) {
    ws.send(JSON.stringify(msg));
  }
};

module.exports = {
    init,
    send
}